export default __webpack_public_path__ + "static/media/q7_01_sp.0a3b3b5f.jpg";